import { useState, useEffect } from 'react';

function detectDevice(): 'mobile' | 'tablet' | 'desktop' {
  const width = window.innerWidth;
  const height = window.innerHeight;
  // Landscape phone: width 640-1024 but height < 500
  if (width < 640) return 'mobile';
  if (height < 500 && width < 1024) return 'mobile';
  if (width < 1024) return 'tablet';
  return 'desktop';
}

export function useDeviceType() {
  const [deviceType, setDeviceType] = useState<'mobile' | 'tablet' | 'desktop'>(detectDevice);
  
  const [isDesktopView, setIsDesktopView] = useState(() => {
    return localStorage.getItem('forceDesktopView') === 'true';
  });

  const [isLandscape, setIsLandscape] = useState(() => {
    return window.innerWidth > window.innerHeight;
  });

  useEffect(() => {
    const handleResize = () => {
      setDeviceType(detectDevice());
      setIsLandscape(window.innerWidth > window.innerHeight);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleDesktopView = () => {
    const newView = !isDesktopView;
    setIsDesktopView(newView);
    localStorage.setItem('forceDesktopView', String(newView));
  };

  return {
    isMobile: deviceType === 'mobile' && !isDesktopView,
    isTablet: deviceType === 'tablet' && !isDesktopView,
    isDesktop: deviceType === 'desktop' || isDesktopView,
    isLandscape,
    deviceType,
    isDesktopView,
    toggleDesktopView
  };
}
